import { ItemLayer } from '.';
import * as marietta from '../..';
import { TemporaryGroupItemForLidarAddPin } from '../item';

export default class LidarImportLayer extends ItemLayer {
  childList: marietta.webcad.item.MonicaObject[] & marietta.webcad.item.TemporaryGroupItemForLidarAddPin[];

  /**
     * アイテムパーツ作成
     */
  addParts(item) {
    this.spt.addChild(item.spt);

    // アイテム一覧に追加
    this.childList.push(item);
  }

  /**
     * 全てのアイテムの移動
     * @moveX Number X軸移動距離
     * @moveY Number Y軸移動距離
     * */
  moveAllItems(moveX: number, moveY: number): void {
    let target: marietta.webcad.item.TemporaryGroupItemForLidarAddPin;
    for (let i: number = 0; i < this.childList.length; i += 1) {
      target = this.childList[i] as marietta.webcad.item.TemporaryGroupItemForLidarAddPin;
      target.spt.x += moveX;
      target.spt.y += moveY;
      target.spt.update();
    }
  }

  formatList() {
    // 子供一覧の整理（※ないものはリストから削除する）
    for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
      if ((this.childList[i] as TemporaryGroupItemForLidarAddPin).spt == null) {
        // リスト削除
        this.childList.splice(i, 1);
      }
    }
  }

  /**
   * 子供一覧
   * @returns
   */
  getchildList():TemporaryGroupItemForLidarAddPin[] {
    const retList: TemporaryGroupItemForLidarAddPin[] = [];
    //   let id: String;

    // 子供一覧の整理（※ないものはリストから削除する）
    for (let i: number = this.childList.length - 1; i >= 0; i -= 1) {
      if ((this.childList[i] as TemporaryGroupItemForLidarAddPin).spt == null) {
        // リスト削除
        this.childList.splice(i, 1);
      }
    }
    // 返却リストの作成
    for (let i = 0; i < this.childList.length; i += 1) {
      retList.push(this.childList[i]);
    }
    return retList;
  }
}
